import React from 'react';

const DownloadFileIcon = (props) => (
    <svg
        width="13"
        height="14"
        viewBox="0 0 13 14"
        fill="none"
        {...props}
    >
        <path
            d="M10.9922 8.57031L10.9922 10.6641C10.9922 10.9417 10.8819 11.208 10.6856 11.4043C10.4892 11.6006 10.223 11.7109 9.94531 11.7109L2.61719 11.7109C2.33954 11.7109 2.07326 11.6006 1.87693 11.4043C1.68061 11.208 1.57031 10.9417 1.57031 10.6641L1.57031 8.57031"
            stroke="currentColor"
            strokeWidth="1.07752"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.66394 5.95264L6.28113 8.56982L8.89832 5.95264"
            stroke="currentColor"
            strokeWidth="1.07752"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.28149 8.57031L6.28149 2.28906"
            stroke="currentColor"
            strokeWidth="1.07752"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default DownloadFileIcon;
